"use client";

import { useTranslations } from "next-intl";
import { Link, usePathname } from "@/i18n/navigation";
import { cn } from "@/lib/utils";
import { isNavDestinationActive, NAV_DESTINATIONS } from "../nav-destinations";
import { NetworkSignOut } from "./NetworkSignOut";

export const NetworkMenu = ({
  initialPath,
  onNavigate,
}: {
  initialPath?: string;
  onNavigate?: () => void;
}) => {
  const t = useTranslations("nav");
  const pathname = usePathname() || initialPath;
  return (
    <nav aria-label={t("menu")} className="flex flex-col gap-6">
      <div className="space-y-1">
        {NAV_DESTINATIONS.map(({ href, icon: Icon, labelKey }) => {
          const active = isNavDestinationActive(pathname, href);
          return (
            <Link
              key={href}
              href={href}
              onClick={onNavigate}
              aria-current={active ? "page" : undefined}
              className={cn(
                "flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-accent",
                active
                  ? "bg-bg-secondary text-accent"
                  : "text-text-secondary hover:bg-bg-secondary/60 hover:text-text-primary",
              )}
            >
              <Icon
                size={20}
                variant={active ? "Bold" : "Linear"}
                className="shrink-0"
              />
              <span>{t(labelKey)}</span>
            </Link>
          );
        })}
      </div>
      <div className="space-y-2 border-t border-stroke-subtle pt-3">
        <NetworkSignOut onNavigate={onNavigate} />
      </div>
    </nav>
  );
};
